<template>
  <b-container fluid class="mt-50">
    <b-row>
      <b-col cols="12">
        <h4 class="f-default">
          <router-link to="/loki">
            <i class="bi bi-arrow-left"></i
          ></router-link>
          Detalhes de {{ title }}
        </h4>
      </b-col>
    </b-row>
    <b-row v-if="title !== 'domain'">
      <b-col cols="12" xl="6" class="pr-xl-2">
        <b-card>
          <graph-data-based
            :axisAndSeries="axisAndSeries"
            :data="dataGraphLinear"
            :max="max + 2"
            v-if="dataGraphLinear.length > 0"
            :geometric-form="false"
          />
          <b-alert show variant="warning" class="w-100 mb-0" v-else>
            <p class="f-default mb-0 text-center">Nenhum dado encontrado</p>
          </b-alert>
        </b-card>
      </b-col>
      <b-col cols="12" xl="6" class="pl-xl-2">
        <b-card>
          <graph-donnuts
            :data="dataPie"
            :label="`Findings ${title}`"
            v-if="dataPie.length > 0"
            theme="animated"
          />
          <b-alert show variant="warning" class="w-100 mb-0" v-else>
            <p class="f-default mb-0 text-center">Nenhum dado encontrado</p>
          </b-alert>
        </b-card>
      </b-col>
    </b-row>
    <b-row class="py-3 d-flex justify-content-end">
      <b-col cols="12" md="3" v-if="title === 'string' || title === 'vips'">
        <app-select
          :data="{
            options: listOrigins,
            valueDefault: 'Origens',
            required: true,
          }"
          v-model="originFinding"
        />
      </b-col>
      <b-col cols="12" md="3">
        <app-select
          :data="{
            options: statusFindings,
            valueDefault: 'Status',
            required: true,
          }"
          v-model="statusFinding"
        />
      </b-col>
      <b-col cols="12" md="3">
        <v-date-picker v-model="range" is-range :masks="masks" locale="pt">
          <template v-slot="{ inputValue, inputEvents }">
            <div class="flex justify-center items-center">
              <b-form-input
                :value="`${
                  inputValue.start !== null
                    ? `${inputValue.start} - ${inputValue.end}`
                    : '-----'
                } `"
                v-on="inputEvents.start"
              />
              <button @click="range = ''" class="btn-x">
                <i class="bi bi-x-circle"></i>
              </button>
            </div>
          </template>
        </v-date-picker>
      </b-col>
      <b-col cols="6" md="3" class="d-flex justify-content-center">
        <b-button variant="secondary" class="w-50" @click="cleanFn"
          >Limpar</b-button
        >
        <b-button variant="primary" @click="searchFn" class="w-50 ml-2"
          >Pesquisar</b-button
        >
      </b-col>
    </b-row>
    <b-row class="mt-4">
      <b-col cols="12">
        <app-table
          :data-array="items"
          :fields="fields"
          @keyword="setFilter('search', $event)"
          @perPage="setFilter('size', $event)"
          @currentPage="setFilter('page', $event)"
          :rows="rows"
        >
          <template v-slot:payload="{ data }">
            <p style="max-width: 500px">
              <span
                v-html="
                  data.item.payload.replaceAll('?', '').replaceAll('\n', '<br>')
                "
              ></span>
            </p>
          </template>
          <template v-slot:description="{ data }">
            <p style="max-width: 600px">
              {{ data.item.description }}
            </p>
          </template>
          <template v-slot:online="{ data }">
            <b-badge :variant="data.item.online ? 'success' : 'danger'">{{
              data.item.online ? 'Online' : 'Offline'
            }}</b-badge>
          </template>
          <template v-slot:domainsuspect="{ data }">
            <a :href="data.item.domainsuspect" target="_blank">{{
              data.item.domainsuspect
            }}</a>
          </template>
          <template v-slot:urlMatch="{ data }">
            <a :href="data.item.urlMatch" target="_blank">{{
              data.item.urlMatch.slice(0, 70) + '...'
            }}</a>
          </template>
          <template v-slot:urlReference="{ data }">
            <a :href="data.item.urlReference" target="_blank">{{
              data.item.urlReference
                ? data.item.urlReference.slice(0, 70) + '...'
                : '--'
            }}</a>
          </template>

          <template v-slot:statusInternal="{ data }">
            <app-select
              v-if="data.item.statusInternal !== ''"
              :data="{
                options: statusFindings,
                valueDefault: 'Status',
                required: true,
              }"
              v-model="data.item.statusInternal"
              @input="changeSelect(data.item, data.item.statusInternal)"
            />
          </template>
          <template v-slot:status="{ data }">
            <app-select
              v-if="data.item.status !== ''"
              :data="{
                options: statusFindings,
                valueDefault: 'Status',
                required: true,
              }"
              v-model="data.item.status"
              @input="changeSelect(data.item, data.item.status)"
            />
          </template>
        </app-table>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import graphDataBased from '@/components/graphs/_dataBased'
import graphDonnuts from '@/components/graphs/_donnuts'
import api from '@/services/api'
import moment from 'moment'
import { mixins } from '@/mixins/mixins'
export default {
  components: {
    graphDataBased,
    graphDonnuts,
  },
  mixins: [mixins],
  metaInfo: {
    title: 'Loki',
    titleTemplate: '',
  },
  beforeMount() {
    this.title = this.$route.params.origin
    this.getInformation()
  },
  data() {
    return {
      title: '',
      range: '',
      search: '',
      masks: {
        input: 'DD/MM/YYYY',
      },
      axisAndSeries: [],
      dataGraphLinear: [],
      dataPie: [],
      fields: [],
      items: [],
      max: 0,
      statusFindings: [],
      statusFinding: '',
      listOrigins: [],
      originFinding: '',
    }
  },
  methods: {
    async changeSelect(event, status) {
      this.$store.commit('utils/setLoading', true)
      const statusId = this.statusFindings.find((ft) => {
        return ft.value === status
      })
      try {
        let payload = {
          status: statusId.text,
          clientid: this.$route.query.client,
          domain: event.domainsuspect,
          hashTitleId: event.hashTitleId,
        }
        let pathParam = this.$route.query.id

        if (this.title === 'domain') {
          pathParam = 'update'
        }
        if (this.title === 'leaks') {
          pathParam = event.domainLeakId
        }
        await api.changeStatusDetails(
          pathParam,
          payload,
          this.title,
          this.$route.query.type,
          event.id
        )
        this.getInformation()
      } catch (error) {
        this.errorCatch(error)
      } finally {
        this.$store.commit('utils/setLoading', false)
      }
    },
    cleanFn() {
      this.statusFinding = ''
      this.range = ''
      this.originFinding = ''
    },
    searchFn() {
      this.$store.commit('utils/setLoading', true)
      let date = {
        startDate:
          this.range !== ''
            ? moment(this.range.start).format('DD/MM/yyyy')
            : '',
        endDate:
          this.range !== '' ? moment(this.range.end).format('DD/MM/yyyy') : '',
      }
      this.filter.status = ''
      if (this.statusFinding !== '') {
        const status = this.statusFindings.filter(
          (ft) => ft.value === this.statusFinding
        )
        this.filter.status = status[0].text
      }

      this.filter.origin = this.originFinding
      this.filter = Object.assign(this.filter, date)
      this.getDetails()
    },

    async getInformation() {
      this.$store.commit('utils/setLoading', true)

      await this.getStatus()
      this.getDetails()
      if (this.title !== 'domain') {
        this.getLineChart()
        this.getDonutChart()
      }
      if (this.title === 'string' || this.title === 'vips') {
        this.getOriginList()
      }
    },
    async getOriginList() {
      try {
        const { data } = await api.getOriginList(
          this.$route.query.id,
          this.title
        )
        this.listOrigins = data.map((mp) => {
          return {
            value: mp,
            text: mp,
          }
        })
      } catch (error) {
        this.errorCatch(error)
      }
    },
    async getStatus() {
      try {
        const { data } = await api.getStatusLokiFinding()
        this.statusFindings = Object.entries(data).map(([key, value]) => {
          return {
            value: key,
            text: value,
          }
        })
      } catch (error) {
        this.errorCatch(error)
      } finally {
        this.$store.commit('utils/setLoading', false)
      }
    },
    async getLineChart() {
      this.$store.commit('utils/setLoading', true)

      try {
        const { data } = await api.getLineChartDetails(
          this.$route.query.id,
          this.$route.query.client,
          this.title,
          this.$route.query.type
        )
        const keys = data.arrayGraphs.map((a) => {
          return Object.keys(a)
        })
        const array = []
        keys.forEach((mp) => {
          mp.forEach((el) => {
            if (array.includes(el) || el === 'date') return
            array.push(el)
          })
        })
        array.forEach((el) => {
          this.axisAndSeries.push({
            field: el,
            name: el,
            opposite: false,
          })
        })
        this.dataGraphLinear = data.arrayGraphs.map((mp) => {
          return {
            date: new Date(mp.date[0], mp.date[1], mp.date[2]),
            ...mp,
          }
        })

        this.max = data.max
      } catch (error) {
        this.errorCatch(error)
      } finally {
        this.$store.commit('utils/setLoading', false)
      }
    },
    async getDonutChart() {
      this.$store.commit('utils/setLoading', true)

      try {
        this.dataPie = []
        const { data } = await api.getDonutDetails(
          this.$route.query.id,
          this.$route.query.client,
          this.title,
          this.$route.query.type
        )
        this.dataPie = data
      } catch (error) {
        this.errorCatch(error)
      } finally {
        this.$store.commit('utils/setLoading', false)
      }
    },
    async getDetails() {
      try {
        const { data } = await api.getDetailsAll(
          this.$route.query.id,
          this.$route.query.client,
          this.filter,
          this.title,
          this.$route.query.type
        )
        if (this.title === 'string') {
          this.fields = [
            { key: 'urlMatch', label: 'Url ' },
            { key: 'searchString', label: 'String de Busca' },
            { key: 'findingOrigin', label: 'Origem' },
            { key: 'firstSeen', label: 'Primeira Identificação' },
            { key: 'lastSeen', label: 'Última Identificação' },
            { key: 'statusInternal', label: 'Status' },
          ]
        } else if (this.title === 'domain') {
          this.fields = [
            { key: 'domainsuspect', label: 'Domínios' },
            { key: 'firstSeen', label: 'Primeira Identificação' },
            { key: 'lastSeen', label: 'Última Identificação' },
            { key: 'online', label: 'Disponibilidade' },
            { key: 'httpstatus', label: 'Código de Resposta' },
            { key: 'statusInternal', label: 'Status' },
          ]
        } else if (this.title === 'channels') {
          this.fields = [
            { key: 'id', label: 'ID' },
            { key: 'msgUser', label: 'Usuário' },
            { key: 'msgdate', label: 'Data de mensagem' },
            { key: 'payload', label: 'Mensagem' },
            { key: 'statusInternal', label: 'Status' },
          ]
        } else if (this.title === 'vips') {
          this.fields = [
            { key: 'urlMatch', label: 'Url ' },
            { key: 'findingOrigin', label: 'Origem' },
            { key: 'firstSeen', label: 'Primeira Identificação' },
            { key: 'lastSeen', label: 'Última Identificação' },
            { key: 'statusInternal', label: 'Status' },
          ]
        } else if (this.title === 'leaks') {
          this.fields = [
            { key: 'domainLeakId', label: 'ID' },
            { key: 'leaks.user', label: 'Email' },
            { key: 'leaks.leakName', label: 'Breach' },
            // { key: 'statusInternal', label: 'Status' },
          ]
        } else if (this.title === 'axur') {
          if (this.$route.query.type === 'one') {
            this.fields = [
              { key: 'id', label: 'ID' },
              { key: 'urlReference', label: 'URL' },
              { key: 'creationDate', label: 'Data de criação' },
              { key: 'detectionDate', label: 'Data de detecção' },
              { key: 'statusInternal', label: 'Status' },
            ]
          } else {
            this.fields = [
              { key: 'alertId', label: 'ID' },
              { key: 'description', label: 'Descrição' },
              { key: 'platform', label: 'Plataforma' },
              { key: 'profile', label: 'Perfil' },
              { key: 'createdAt', label: 'Data de criação' },
              { key: 'status', label: 'Status' },
            ]
          }
          //alertId
          //createdAt
          //criticality
          //platform
          //profile
          //status
          //description

          //
        }
        this.rows = data.totalElements
        if (!data.content) return
        this.items = data
        this.items.content = data.content.map((mp) => {
          return {
            ...mp,
            statusInternal: mp.status,
          }
        })
        console.log('Entrou', this.items, this.title)
      } catch (error) {
        this.errorCatch(error)
      } finally {
        this.$store.commit('utils/setLoading', false)
      }
    },

    setFilter(step, event) {
      switch (step) {
        case 'search':
          this.filter.search = event
          break
        case 'page':
          this.filter.page = event
          break
        case 'size':
          this.filter.size = event
          break
      }
      this.getDetails()
    },
  },
}
</script>
<style lang="scss"></style>
